var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "fixed z-50 w-screen transition duration-300 delay-200",
      class: { scrollup: _vm.sticky, "delay-300": _vm.sticky }
    },
    [
      _c("div", { staticClass: "bg-blue usp-bar py-8 text-white" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _vm.$store.getters["isReseller"]
                ? _c("p", {
                    staticClass: "transform -translate-y-1 w-full text-center",
                    staticStyle: { "line-height": "1.25rem" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.headerData.reseller_tekst.replace(
                          /\{{(.+?)\}}/g,
                          _vm.$store.getters["percentage"]
                        )
                      )
                    }
                  })
                : _vm._l(_vm.headerData.header_usps, function(usp, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "lg:w-1/3 first:flex lg:flex items-center justify-center hidden w-full transition-opacity delay-200"
                      },
                      [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.svg(usp.svg_name, "fill-current mr-8")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "transform -translate-y-1",
                          staticStyle: { "line-height": "1.25rem" },
                          domProps: { innerHTML: _vm._s(usp.description) }
                        })
                      ]
                    )
                  })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md:pt-32 md:pb-24 py-16 bg-white border-b border-gray-300"
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "flex items-center justify-center" }, [
              _c(
                "div",
                { staticClass: "flex items-center flex-1 mr-auto" },
                [
                  _c(
                    "menu-toggle",
                    { staticClass: "flex items-center mr-40" },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.svg(
                              "hamburger-static",
                              "fill-current text-blue mr-16 mt-2 "
                            )
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "text-dark md:inline hidden font-bold",
                        domProps: {
                          innerHTML: _vm._s(_vm.headerData.menu_label)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "lg:flex items-center hidden",
                      attrs: { href: "/producten" }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.svg(
                              "grid",
                              "fill-current text-blue mr-16 mt-2 "
                            )
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "text-dark font-bold",
                        domProps: {
                          innerHTML: _vm._s(_vm.headerData.products_label)
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center justify-end flex-1 ml-auto" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "text-blue md:inline-block hidden mr-32",
                      attrs: { href: "/contact" }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.svg("mail", "fill-current "))
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "search-bar",
                    {
                      staticClass: "mr-16",
                      attrs: { placeholder: _vm.headerData.search_placeholder }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text-blue md:inline-block hidden mr-16"
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.svg("search", "fill-current ")
                              )
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "shopping-basket-counter",
                    {
                      staticClass: "text-blue",
                      attrs: { href: "/winkelmandje" }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.svg("shopping-cart", "fill-current ")
                          )
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "lg:flex items-center justify-center hidden py-16 bg-white border-b border-gray-300"
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "/" } }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: "/svg/induline.svg", alt: "Induline" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }